import React, { Fragment } from 'react';
import ThemeProvider from '../../../styles/ThemeProvider.mjs';
import darkTheme from '../../../styles/darkTheme.mjs';
import { Size } from '../../../styles/theme.mjs';
import Container from '../../Basic/Container/Container.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import MobileOnly from '../../Containers/MobileOnly/MobileOnly.mjs';
import HorizontalCarousel from '../HorizontalCarousel/HorizontalCarousel.mjs';
import MediaCard from '../MediaCard/MediaCard.mjs';
import { StyledLineSeparator, StyledCategoryLink } from './TopStories.styles.mjs';
import { useTheme } from 'styled-components';

const TopStories = ({ stories, sectionLink, onMediaCardClick }) => {
    const theme = useTheme();
    const fullWidthStories = stories.slice(0, 3);
    const mobileCarouselStories = stories.slice(3);
    return (stories.length > 0 && (React.createElement(ThemeProvider, { theme: darkTheme },
        React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.sm },
            React.createElement(HorizontalCarousel, null, stories.map((story, index) => (React.createElement(MediaCard, { durationTime: story.durationTime, heading: story.heading, thumbnail: {
                    alt: story.heading,
                    src: story.thumbnail
                }, onClick: () => onMediaCardClick(story, index), key: story.id, href: story.href }))))),
        React.createElement(MobileOnly, { breakpoint: theme.breakpoints.sm },
            fullWidthStories.map(({ durationTime, id, heading, thumbnail, href }) => (React.createElement(Fragment, { key: id },
                React.createElement(StyledLineSeparator, null),
                React.createElement(MediaCard, { durationTime: durationTime, heading: heading, thumbnail: {
                        alt: heading,
                        src: thumbnail
                    }, href: href, fullWidth: true })))),
            mobileCarouselStories.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(StyledLineSeparator, null),
                sectionLink && (React.createElement(StyledCategoryLink, { href: sectionLink.href, size: Size.Regular, uppercased: true, withMarker: true }, sectionLink.name)),
                React.createElement(Container, { margin: "0 0 1.5rem", padding: "0" },
                    React.createElement(HorizontalCarousel, null, mobileCarouselStories.map(({ durationTime, id, heading, thumbnail, href }) => (React.createElement(MediaCard, { durationTime: durationTime, heading: heading, thumbnail: {
                            alt: heading,
                            src: thumbnail
                        }, key: id, href: href })))))))))));
};

export { TopStories as default };
//# sourceMappingURL=TopStories.mjs.map
